import {
    Box,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    Text,
    Button,
    Checkbox,
    HStack,
    Spinner,
    VStack,
} from '@chakra-ui/react';
import { useContext, useState, useEffect, memo } from 'react';
import { Icon } from '@blueprintjs/core';
import UIContext from '../context/UIContext';
import moment from 'moment';

const AttributionsModal = ({ isOpen, onClose }) => {
    const [data, setData] = useState(false);
    const { getAttributions } = useContext(UIContext);

    const checkFn = async () => {
        const newData = await getAttributions();
        setData(newData);
    }
    useEffect(() => {
        if (isOpen) {
            setData(null);
            checkFn();
        }
    }, [isOpen]);

    return (
        <Modal size="2xl" isOpen={isOpen} closeOnEsc={false} closeOnOverlayClick={false}>
            <ModalOverlay />
            <ModalContent ml="10px" mr="10px" borderRadius="3px">
                <ModalHeader>Data Attributions</ModalHeader>
                <ModalBody>
                    <Text fontSize="16px" mb="24px">
                        Vector Charts uses data from the following vendors:
                    </Text>
                    {!data && <Spinner speed="3s" size="lg" thickness="3px" opacity="0.5" />}
                    {data && <VStack justifyContent="stretch" alignItems="stretch">
                        {data.map((item) => (
                            <Box border="2px solid rgba(0,0,0,0.08)" bg="rgba(245,245,245,1.0)" p="10px" pb="10px" pr="20px" borderRadius="3px" shadow="sm" mb="5px" 
                            _hover={{
                                cursor: "pointer",
                                border: "2px solid #3182ce",
                                bg: "#bee3f8"
                            }} onClick={() => {
                                window.open(item.sourceUrl || "", '_blank');
                            }}>
                                <HStack width="100%" justifyContent="flex-start" alignItems="flex-start">
                                <Text opacity="0.2" mr="5px"><Icon icon="document" size="32"></Icon></Text>
                                <VStack justifyContent="flex-start" alignItems="flex-start">
                                <Text fontWeight="500">{item.shortDescription}</Text>
                                <Text fontWeight="400">{item.longDescription}</Text>
                                <Text opacity="0.5">
                                    <Icon icon="time"></Icon>&nbsp;
                                    Downloaded on {moment(item.dataSourcedAt).format("MM/DD/YYYY")}, processed on {moment(item.dataProcessedAt).format("MM/DD/YYYY")}</Text>
                                </VStack>
                                <Box flex="1"></Box>
                                <Text flex="0 0 auto" color="blue.500" fontWeight="500" opacity="0.75">View <Icon icon="arrow-top-right"></Icon></Text>
                                </HStack>
                            </Box>
                        ))}
                    </VStack>}
                </ModalBody>

                <ModalFooter>
                    <Button mr={0} onClick={() => {
                        onClose();
                    }} variant="outline" >
                        Close
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default AttributionsModal;
